import * as React from 'react';
import { Button, FlexRow, FormCell, Grid } from 'ui-toolkit';
import { IRecordedDeed } from '../classes/RecordedDeed';
import getText from '../utils/getText';
import DateText from './fields/DateText';
import TimeText from './fields/TimeText';

interface IExistingRecordedDeed {
  data: IRecordedDeed;
  onEditClick: (title?: string) => void;
}

// tslint:disable-next-line:function-name
const RecordedDeedBlock: React.FunctionComponent<IExistingRecordedDeed> = (props) => {
  const onEditClick = () => {
    props.onEditClick(getText('recordedDeed.editNew'));
  };

  return (
    <Grid>
      <FlexRow justifyContent={'space-between'}>
        <h2>{`${getText('recordedDeed.new')} Details`}</h2>
        <Button intent="secondary" onClick={onEditClick}>
          Edit
        </Button>
      </FlexRow>
      <Grid columnCount={4}>
        <FormCell label={'Recorded date'}>
          <DateText date={props.data.recorded_date} />
        </FormCell>
        <FormCell label={'Recorded time'}>
          <TimeText time={props.data.recorded_at} />
        </FormCell>
        <FormCell label={'Executed date'}>
          <DateText date={props.data.execution_date} />
        </FormCell>
      </Grid>
    </Grid>
  );
};

export default RecordedDeedBlock;
